import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../hooks/auth';

import Authorized from '../pages/Layouts/Authorized';
import NotAuthorized from '../pages/Layouts/NotAuthorized';

function getParsedUserRoles(userRoles) {
    if (userRoles == null) return [];
    try {
        return Array.isArray(userRoles) ? userRoles : JSON.parse(userRoles || '[]');
    } catch {
        return [];
    }
}

const Route = ({ isPrivate = false, component: Component, allowedRoles, allowedCulture, ...rest }) => {
    const { user, userRoles } = useAuth();
    const cultureID = localStorage.getItem('@Thrive:cultureID');
    const roles = getParsedUserRoles(userRoles);

    if (user) {
        const rolesMatch = allowedRoles == null || allowedRoles.some(role => roles.includes(role));
        const cultureMatch = allowedCulture == null || allowedCulture.length === 0 ||
            allowedCulture.some(culture => String(culture) === String(cultureID));
        if (!rolesMatch || !cultureMatch) {
            return <Navigate to="/" replace />;
        }
    }

    if (!user && isPrivate) {
        return <Navigate to="/signin" replace />;
    }

    const Layout = user && roles.length > 0 ? Authorized : NotAuthorized;

    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default Route;
